import { Form, Formik, FormikValues } from "formik";
import { Button, Card, Input } from "../../custom";
import styles from "./style.module.scss";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { resetPassword } from "../../utils/auth_request";
import { validator } from "../../utils/validator";
import { routes } from "../../routes";

const validationSchema = Yup.object().shape({
  password: validator.password,
  confirmPassword: validator.confirmPassword,
});

const ResetPassword = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token") ?? "";
  const email = queryParams.get("email") ?? "";

  const resetPasswordMutation = useMutation({
    mutationKey: ["reset-password"],
    mutationFn: resetPassword,
  });

  const handleResetPassword = async (
    values: FormikValues
    // resetForm: () => void
  ) => {
    const payload: ResetPasswordPayload = {
      email: email,
      password: values.password,
      confirmPassword: values.confirmPassword,
      token: token,
    };

    try {
      await resetPasswordMutation.mutateAsync(payload, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          setTimeout(() => {
            navigate(routes.auth.login);
          }, 1000);
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  return (
    <section className={styles.container}>
      <div>
        <Card>
          <div className={styles.cardChild}>
            <div>
              <h3>Welcome to our portal</h3>
              <p>Enter new password and confirm it</p>
            </div>

            <div>
              <div>
                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={(values) => {
                    handleResetPassword(values);
                  }}
                >
                  {(props) => {
                    return (
                      <Form>
                        <div className={styles.formStyle}>
                          <Input
                            name="password"
                            type="password"
                            label="Password:"
                          />
                          <Input
                            name="confirmPassword"
                            label="Confirm Password:"
                            type="password"
                          />
                        </div>

                        <div>
                          <div>
                            <Button
                              text="SUBMIT"
                              type="submit"
                              disabled={resetPasswordMutation?.isPending}
                              isLoading={resetPasswordMutation?.isPending}
                            />
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            <Link to={routes.auth.login}>
              <p>Back to login</p>
            </Link>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default ResetPassword;
